<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="4" lg="4" xl="4">
                <v-toolbar-title class="ml-2 mt-2">Espaços GC</v-toolbar-title>
            </v-col>
            <v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">   
                <v-btn
                    class="ml-2 my-1"
                    color="primary"                     
                    @click="exportar()"   
                >
                    <v-icon left>mdi-microsoft-excel</v-icon> Exportar                    
                </v-btn>               
                <v-btn
                    class="ml-2 my-1"
                    color="primary"                     
                    @click="abrirImportar()"   
                >
                    <v-icon left>mdi-upload</v-icon> Importar                    
                </v-btn>              
            </v-col>            
        </v-row>
        <v-card class="mt-2 py-4 px-2" elevation="1">  
            <v-row no-gutters class="mb-2">
                <v-col cols="12" sm="12" md="6" lg="8" xl="8">
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="4" xl="4" align="end">                     
                    <v-text-field
                        v-model="busca"
                        append-icon="mdi-magnify"
                        label="Pesquisar"
                        dense 
                        outlined
                        hide-details
                    ></v-text-field>     
                </v-col>            
            </v-row>          
            <v-data-table
                :headers="headers"
                :items="dados"
                item-key="id_espaco_gc"
                :server-items-length="total" 
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, 25, 50, 100]
                }"
                :options.sync="pagination"
                multi-sort
                class="elevation-0"
            >
                <template v-slot:[`item.espaco_trade`]="{ item }">
                    {{ item.espaco_trade ? `${item.codigo_rd_trade} - ${item.espaco_trade}` : "-" }}
                </template>
                <template v-slot:[`item.botao`]="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        color="primary"
                        @click="abrirEditar(item)"
                        title="Editar"
                    >
                        mdi-pencil
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <v-dialog
            v-model="dialogo"
            width="600"            
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Editar Espaço
                </v-card-title>
                <v-card-text class="mt-4"> 
                    <v-form v-model="validaForm"> 
                        <v-row no-gutters class="mt-4">
                            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2">
                                <v-text-field
                                    outlined
                                    dense
                                    disabled
                                    label="ID Espaço"
                                    v-model="espaco.id_espaco_gc"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2">
                                <v-text-field
                                    outlined
                                    dense
                                    disabled
                                    label="Espaço Trade"
                                    :value="espaco.espaco_trade ? `${espaco.codigo_rd_trade} - ${espaco.espaco_trade}` : 'Não vinculado'"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="px-2">
                                <v-text-field
                                    outlined
                                    dense
                                    label="Nome"
                                    :rules="regra.nome"
                                    v-model="espaco.nome"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2">
                                <v-text-field
                                    outlined
                                    dense
                                    type="number"
                                    label="Ordem"
                                    v-model="espaco.ordem"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="12" md="6" lg="6" xl="6" class="px-2">
                                <v-select
                                    label="Ativo"
                                    :items="lista_ativo"
                                    item-text="nome"
                                    item-value="ativo"
                                    v-model="espaco.ativo"
                                    outlined
                                    dense
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogo = false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        :disabled="!validaForm"
                        @click="editar()"
                    >
                        <v-icon left>mdi-content-save</v-icon> Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialogoImportar"
            width="90%"            
        >  
            <v-card>
                <v-card-title class="subtitle-1 primary white--text">
                    Importar CSV
                </v-card-title>
                <v-card-text>
                    <v-alert
                        class="mt-4"
                        text
                        type="info"
                        border="left"
                        style="font-size: 12px;"
                    >
                        <ul>
                            <li>
                                A base utilizada para importação deve ser parecida com base exportada. As colunas <strong>id_espaco_gc</strong>, 
                                <strong>ativo</strong> e <strong>nome</strong> são obrigatórias 
                                (<strong>e os nomes devem ser identicos aos da base exportada</strong>), as demais colunas podem ser excluidas.
                            </li>
                            <li>
                                Na coluna <strong>ativo</strong> coloque <strong>SIM</strong> ou <strong>NÃO</strong>, 
                                qualquer valor diferente de <strong>SIM</strong> e <strong>NÃO</strong> será considerado como <strong>NÃO</strong>.
                            </li>
                        </ul>  
                    </v-alert> 
                    <v-row no-gutters>  
                        <v-col cols="8" class="px-2">
                            <v-form ref="form" v-model="isCsv">
                                <v-file-input 
                                    label="Arquivo CSV" 
                                    outlined 
                                    dense
                                    v-model="arquivoCSV"
                                    :rules="regra.csv"
                                    accept=".csv"
                                ></v-file-input>
                            </v-form>
                        </v-col> 
                        <v-col cols="4" class="px-2">
                            <v-btn
                                color="primary"
                                :disabled="!isCsv"
                                @click="importar()"
                            >
                                <v-icon left>mdi-upload</v-icon> 
                                Importar Arquivo
                            </v-btn>
                        </v-col> 
                    </v-row> 
                    <v-expand-transition>
                        <div v-show="erro">                            
                            <v-row no-gutters class="mb-0">  
                                <v-col cols="6">
                                    <download-csv
                                        :data="erros"
                                        :labels="errosLabels"
                                        name= "erros.csv"
                                        delimiter=";"
                                    >
                                        <v-btn color="primary">
                                            <v-icon left>mdi-microsoft-excel</v-icon>
                                            Exportar Erros
                                        </v-btn>
                                    </download-csv>
                                </v-col>
                            </v-row> 
                            <v-data-table                            
                                :headers="headerErros"
                                :items="erros"
                                :items-per-page="5"
                                :options.sync="paginationErros" 
                                class="elevation-0 data-table-1"
                            ></v-data-table>
                        </div>
                    </v-expand-transition>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>                    
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        class="pr-4"
                        @click="dialogoImportar=false"
                    >
                        <v-icon left>mdi-close</v-icon> Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>        
            <v-btn
                dark
                text
                class="float-right"
                @click="alerta=false"
            >
            Fechar
            </v-btn>
        </v-snackbar>  

    </v-container>
</template>

<script>

export default {
	// components: {
		// AddGrupoEspaco,
	// },
	data() {
		return {
			headers: [
				{ text: "ID Espaço", value: "id_espaco_gc", align: "center" },
				{ text: "Nome", value: "nome", align: "center" },
				{ text: "Espaço Trade", value: "espaco_trade", align: "center" },
				{ text: "Ativo", value: "ativo_formatado", align: "center" },
				{ text: "Usuário Criação", value: "usuario_criacao", align: "center" },
				{ text: "Usuário Atualização", value: "usuario_atualizacao", align: "center" },
				{ text: "Data Criação", value: "data_criacao_formatado", align: "center" },
				{ text: "Data Atualização", value: "data_atualizacao_formatado", align: "center" },
				{ text: "", value: "botao", align: "center", sortable: false },
			],
			dados: [],
			espaco: {
				id_espaco_gc: null,
				nome: null,
				ativo: null,
				ordem: null,
				id_usuario_criacao: null,
				id_usuario_atualizacao: null,
				data_criacao: null,
				data_atualizacao: null,
			},
			espaco_grupos: [],
            lista_ativo: [
                { ativo: true, nome: "Sim" },
                { ativo: false, nome: "Não" },
            ],
			openAddGrupoEspaco: false,
			pagination: {},
			paginationErros: {},
			total: null,
			carregando: false,
			busca: null,
			dialogo: false,
			dialogoImportar: false,
			validaForm: false,
			alerta: false,
			alertaTexto: "",
			alertaColor: "error",
			alertaTimeout: 3000,
			arquivoCSV: null,
			regra: {
				csv: [
					(v) => !!v || "Selecione um arquivo.",
					(v) =>
						(!!v && [".csv", ".CSV"].includes(v.name.substr(-4))) ||
						"O arquivo deve ser do tipo CSV.",
				],
                nome: [
					(v) => !!v || "O campo nome é obrigatório.",
				],
			},
			isCsv: false,
			headerErros: [
                { text: "Linha", value: "line", align: "center" },
				{ text: "Descrição do Erro", value: "messageFormatted", align: "left" },
			],
			erros: [],
			errosLabels: { msg: "Descrição do Erro" },
			erro: false,
		};
	},
	watch: {
		pagination: {
			handler() {
				this.filtrar();
			},
			deep: true,
		},
		busca(v) {
			setTimeout(() => {
				if (v == this.busca) {
					this.filtrar();
				}
			}, 1500);
		},
	},
	created() {},
	computed: {
		isCubo() {
			return (this.espaco.nome || "").toLowerCase().includes("cubo");
		},
	},
	methods: {
		async filtrar() {
			this.carregando = true;

			const data = {};
			data.pagination = this.pagination;
			data.busca = this.busca;

			const responseAPI = await this.$http().post("/espacoGC/lista", {
				data: data,
			});
            const response = responseAPI.data;

            if (!response.success){
                this.carregando = false;
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = -1;
                this.alertaTexto = response.msg;
                return;
            }

			this.dados = response.result;
			this.total = response.result.length ? response.result[0].total : 0;

			if (this.total == 0 && this.pagination.page > 1) {
				this.pagination.page = 1;
				this.filtrar(false);
			}

			this.carregando = false;
		},
		async exportar() {
			this.carregando = true;

			const data = {};
			const response = await this.$http().post("/espacoGC/exportar", {
				data: data,
			});

            if (!response.data.success && !response.data.url){
                this.carregando = false;
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = -1;
                this.alertaTexto = response.data.msg;
                return;
            }

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		abrirEditar(item) {
			this.espaco = { ...item };

			this.dialogo = true;
		},
		async editar() {
			this.carregando = true;

			var data = this.espaco;

			var response = await this.$http().post("/espacoGC/editar", {
				data: data,
			});

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();
				this.dialogo = false;
			} else {
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = -1;
				this.alertaTexto = response.data.msg;
			}
		},
		abrirImportar() {
			this.arquivoCSV = null;
			this.erro = false;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			this.dialogoImportar = true;
		},
		async importar() {
			this.carregando = true;

			var formData = new FormData();

			formData.append("files", this.arquivoCSV);

			this.arquivoCSV = null;

			try {
				this.$refs.form.resetValidation();
			} catch (error) {
				//console.log(error)
			}

			const response = await this.$http().post(
				"/espacoGC/importar",
				formData
			);

			this.carregando = false;

			if (response.data.success) {
				this.filtrar();
				this.dialogoImportar = false;
			} else {
				this.filtrar();
				this.erros = response.data.result.errors;
				this.pagination.page = 1;
				this.erro = true;
			}
		},
		updateGrupos(grupo) {
			this.espaco_grupos.push(grupo);
			this.espaco.id_espaco_grupo = grupo.id_espaco_grupo;
		},
	},
};
</script>
